import React from "react";
import PropTypes from "prop-types";

export const Shimmer = ({ height = "100%", width = "100%", borderRadius = "0px", style }) => {
  return (
    <div
      className="spinner--shimmer"
      style={{
        width,
        height,
        borderRadius,
        ...style
      }}
      data-testid="shimmer"
    >
      <div className="shimmer__background" />
    </div>
  );
};

Shimmer.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  borderRadius: PropTypes.string
};
